import 'core-js/stable';
import 'regenerator-runtime/runtime';

import 'ol/ol.css';
import 'ol-ext/dist/ol-ext.css';
import 'ol-ext/control/LayerSwitcher.css'
import './ol3-sidebar.css';
import './ol-overrides.css';
import 'jquery-ui-dist/jquery-ui.min.css';
import './style.css';
import './css/analytics.css';

import Map from 'ol/Map';
import View from 'ol/View';
import {defaults as defaultControls, FullScreen, ScaleLine} from 'ol/control';
import {fromLonLat} from 'ol/proj.js';
import VectorLayer from 'ol/layer/Vector.js';
import LayerGroup from 'ol/layer/Group';
import {osm, gerk_mask, slo_wms, vineyardsLayer, profile_settings, page_profile, common_orthophoto} from './layers';
import popup from './popup';

import {WMS} from './wms';
import {Sidebar} from './sidebar';
import {Slider} from './slider';
import {Pdf_out} from './pdf_out';
import {Analytic} from './analytic';
import {LayerOrder} from './layer_order';

const wlayers = require('./layers');

import {Tile as TileLayer} from 'ol/layer';
import OSM from 'ol/source/OSM';

/* LayerSwitcher control */
import LayerSwitcher from 'ol-ext/control/LayerSwitcher'

/* OL ScaleLine */
const scaleBarOptionsContainer = document.getElementById('scaleBarOptions');
 
let merilo = new ScaleLine({
      units: 'metric',
      bar: true,
      steps: parseInt(4, 10),
      text: true,
      minWidth: 140,
    });

var view = new View({
    center: fromLonLat([13.2,46]),
    zoom: 9,
	extent: profile_settings[page_profile]["extent"],
});

var map = new Map({
  controls: defaultControls().extend([
    new FullScreen({
      source: 'fullscreen'
    }),
	merilo
  ]),
  target: 'map',
  view: view
});

//map.getView().fit([1429784.4475407281, 5733988.827906252, 1549625.4990452933, 5795470.193191657], map.getSize());


/* sentinel layers */
/*
const datumLayers = [];
wlayers.sentinelLayers.forEach(function(wlayer){
	//map.addLayer(wlayer);
	datumLayers.push(wlayer);	//sem shranim WMS sloje, ki jim bom spreminjal datum	
});
*/
const satellite_layers = new LayerGroup({title: 'Satellite layers', 
								visible: true, 
								openInLayerSwitcher: true,
								layers: wlayers.sentinelLayers});							

/* Add to map */	
map.addLayer(osm);							
map.addLayer(satellite_layers);
map.addLayer(slo_wms);
map.addLayer(common_orthophoto);
map.addLayer(gerk_mask);

page_profile == 0 && map.addLayer(vineyardsLayer);

import * as olExtent from 'ol/extent';


popup(map,wlayers.popup_array);

var jquery = require("jquery");
window.$ = window.jQuery = jquery;
require("jquery-ui-dist/jquery-ui.js");

/*
* Posodobi datum slojev
*/
const updateLayersDate = (date) => {
  //getSource().updateParams({'TIME': date.toISOString()});
  for (const layer of wlayers.sentinelLayers) {
		slider.setLastDate(new Date(date));	// set last selected date to slider
		layer.getSource().updateParams({'time': date}); //datum v obliki YYYY-MM-DD
  }
}

const slider = new Slider( "#date-slider" );


/*
URL hash class
		-- function sets hash from map or reads hash and sets map
*/

function url_hash(map){
		var that = this;
		this.map = map;	
		
		this.init = function(){
				//check if valid hash exists
				if(window.location.hash && (window.location.hash && window.location.hash.split("_").length == 3)){
					
					var hash = window.location.hash.split("_");
					hash[0] = hash[0].slice(1);
					
					//check if parameters are valid numbers
					for (var i in hash){						
						if(!Number.isFinite(Number(hash[i])))
						{	
							//set hash on map init
							this.setHash();
							return
						}
					}
													
					map.getView().setZoom(hash[0]);				
					map.getView().setCenter([Number(hash[1]),Number(hash[2])]);
										
					return
				}else{
					this.setHash();	
				}				
		},
						
		this.setHash = function(){
				var center = map.getView().getCenter();				
				var hash = [map.getView().getZoom(),center[0],center[1]];
																
				window.location.hash = hash.join("_");
		},
		
		// change hash on map move
		this.location_listener = map.on('moveend', function(e) {	
				that.setHash();
		})
		
		this.init();
				
};



$(function() {
	//activate url_hash
	var hash = new url_hash(map);
	
    // Add a layer switcher outside the map
 var lswitcher = new LayerSwitcher({
    target:$(".layerSwitcher").get(0), 
	show_progress:true,
  });
     
  let sidebar = new Sidebar({ element: 'sidebar', position: 'left' });
  sidebar.open("layers");
  map.addControl(sidebar);  
  map.addControl(lswitcher);

	$( "#date-picker2, #date-picker1").datepicker(
	{
		onSelect: (date) => {
			slider.reload(layer_order.getTopLayerSettings());
			if(analytic){
				analytic.removeChart(false);
				analytic.refreshTimePeriod();
			}
		}
	}
  );
  $( "#date-picker2" ).datepicker("setDate", new Date());
  $( "#date-picker1" ).datepicker("setDate", "-30d");
  
	// current zoom
	let currZoom = map.getView().getZoom();
		map.on('moveend', function(e) {
			let newZoom = map.getView().getZoom();
			  if (currZoom != newZoom) {
				currZoom = newZoom;
			  }
			  
			checkLayerVisibility(currZoom);
		});
	
	// layerswitcher icons
  lswitcher.on('drawlist', function(e) {
    var layer = e.layer;
    // zoom to display text
	$('<div>').text('zoom in to display').appendTo($('> .ol-layerswitcher-buttons', e.li)).addClass("zoom2display");
	
	
	const title = layer.id;
	
	// check if info content exists
	if($('div[data-dialog="'+title+'"]').length > 0){
		
		//add layer info icon
		$('<div>').text('i')// addClass('layerInfo')
		  .click(function(){
					if (!layer.dlg) { //pri prvem kliku na ikono shrani referenco na dialog v sloj				  
					  layer.dlg = $('div[data-dialog="'+title+'"]');
					  //layer.dlg = $('div[title="'+title+'"]');
					}
					let l = layer.dlg.dialog({
						width: 500,
						maxHeight: $( window ).height(),
						title: layer.get("title"),					
					});
					
			})
		  .appendTo($('> .ol-layerswitcher-buttons', e.li));	
	};
	
		checkLayerVisibility(currZoom);			
  });  
  
	
  
	// set visibility depended display in layer list 
	const checkLayerVisibility = (currZoom) => {
		
		lswitcher._layers.forEach(function(layer){				
			if(layer.layer.values_.minZoom > 0){				
					if(layer.layer.values_.minZoom > currZoom){
						$('.ol-layerswitcher label[title="'+layer.layer.values_.title+'"]').parent().css("opacity", 0.5);
						
						// show zoom2display text
						$('.ol-layerswitcher label[title="'+layer.layer.values_.title+'"]')
							.parent()
							.siblings(".ol-layerswitcher-buttons")
							.find(".zoom2display")
							.attr("style", "display:inline-block !important");
					}else{
						$('.ol-layerswitcher label[title="'+layer.layer.values_.title+'"]').parent().css("opacity", 1);
						
						// hide zoom2display text
						$('.ol-layerswitcher label[title="'+layer.layer.values_.title+'"]')
							.parent()
							.siblings(".ol-layerswitcher-buttons")
							.find(".zoom2display")
							.attr("style", "");
					}
			}
		});
	}
});


/*
Analytic
*/
const analytic = new Analytic(map);

export {updateLayersDate};

let layer_order = new LayerOrder(map, slider, ["LST"]);
